import {
  GET_TWILIO_PHONE_NUMBERS_SUCCESS,
  GET_TWILIO_PHONE_NUMBERS_REQUEST,
  RESET_TWILIO_PHONE_NUMBERS,
} from './actionTypes';
import { GET_INITIATIVE_SUCCESS } from '../../Edit/actionTypes';

const initialState = {
  numbers: [{ id: '', phone_number: '—' }],
  loading: false,
};

const initiativeFormReducer = (state = initialState, {
  type, twilioPhoneNumbers, initiativeData,
}) => {
  switch (type) {
    case GET_TWILIO_PHONE_NUMBERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_INITIATIVE_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const existingNumbers = [];
      initiativeData.organizations.forEach((el) => {
        if (el.recruits_twilio_phone_number) {
          existingNumbers.push({
            ...el.recruits_twilio_phone_number,
            id: el.recruits_twilio_phone_number.id.toString(),
          });
        }
        if (el.users_twilio_phone_number) {
          existingNumbers.push({
            ...el.users_twilio_phone_number,
            id: el.users_twilio_phone_number.id.toString(),
          });
        }
      });
      if (existingNumbers) {
        return {
          ...state,
          numbers: [...state.numbers, ...existingNumbers],
        };
      }
      return state;
    case GET_TWILIO_PHONE_NUMBERS_SUCCESS:
      return {
        ...state,
        numbers: [...state.numbers, ...twilioPhoneNumbers],
        loading: false,
      };
    case RESET_TWILIO_PHONE_NUMBERS:
      return initialState;
    default:
      return state;
  }
};

export default initiativeFormReducer;
